import log from 'salvo-lite/log'
import axios from 'axios'

class GEOIP {
    constructor (theme, elem) {
        this.elem = elem
        this.location = {}
        this.options = Object.assign({
            shopCountry: 'GB',
            endpoint: 'https://ssl.geoplugin.net/json.gp?k=2268dc2e1da1ede9',
            redirections: {},
            countryKey: 'geoplugin_countryCode',
            regionKey: 'geoplugin_continentCode',
            cacheTimeout: 1000 * 60 * 10,
            overrideTime: 1000 * 60 * 60 * 24 * 7
        }, JSON.parse(this.elem.innerHTML))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        log.debug(this.constructor.name, 'Initiating')
        log.debug(this.constructor.name, 'Log', this.options)
        this.checkOverride()

        if (sessionStorage.getItem('ESC-GEOIP-OVERRIDE')) {
            return false
        }

        await this.getLocation()
        this.doRedirects()
        log.debug(this.constructor.name, 'Initiated')
    }

    checkOverride () {
        if (this.getParameterByName('override')) {
            sessionStorage.setItem('ESC-GEOIP-OVERRIDE', new Date().getTime())
        }

        if (sessionStorage.getItem('ESC-GEOIP-OVERRIDE')) {
            let epoch = new Date().getTime()
            let overrideTime = parseInt(sessionStorage.getItem('ESC-GEOIP-OVERRIDE'))
            if ((epoch - overrideTime) >= this.options.overrideTime) {
                sessionStorage.removeItem('ESC-GEOIP-OVERRIDE')
            }
        }
    }

    doRedirects () {
        // console.log('location: ', this.location)
        // console.log('OPTIONS: ', this.options)
        // console.log(this.options.redirections)
        if (this.location.geoplugin_countryCode === this.options.shopCountry) {
            return false
        }

        // if continent is eu & not UK & already on EU site, don't redirect
        let isEUSite = true
        if (this.options.redirections.EU.length > 1) {
            isEUSite = false
        }

        if (this.location.geoplugin_continentCode === 'EU' && this.location.geoplugin_countryCode !== 'GB' && isEUSite) {
            return false
        }

        let redirections = this.options.redirections
        let redirected = false
        for (let redirect in redirections) {
            let compareKey = this.options.countryKey
            if (redirect === 'EU') {
                compareKey = 'geoplugin_continentCode'
            }
            if (redirections.hasOwnProperty(redirect)) {
                let currentCountry = this.location[compareKey]
                if (currentCountry === 'CA') {
                    currentCountry = 'US'
                }
                if (currentCountry === redirect) {
                    if (redirect === 'EU') {
                        if (this.location[this.options.countryKey] !== 'GB') {
                            let redirectURL = `${redirections[redirect]}?redirected=true`
                            if (this.getParameterByName('utm_source')) {
                                redirectURL = `${redirectURL}&utm_source=${this.getParameterByName('utm_source')}`
                                if (this.getParameterByName('utm_medium')) {
                                    redirectURL = `${redirectURL}&utm_medium=${this.getParameterByName('utm_medium')}`
                                }
                                if (this.getParameterByName('utm_campaign')) {
                                    redirectURL = `${redirectURL}&utm_campaign=${this.getParameterByName('utm_campaign')}`
                                }
                            }
                            window.top.location.href = redirectURL
                            redirected = true
                            return false
                        } else {
                            let redirectURL = `${redirections.GB}?redirected=true`
                            if (this.getParameterByName('utm_source')) {
                                redirectURL = `${redirectURL}&utm_source=${this.getParameterByName('utm_source')}`
                                if (this.getParameterByName('utm_medium')) {
                                    redirectURL = `${redirectURL}&utm_medium=${this.getParameterByName('utm_medium')}`
                                }
                                if (this.getParameterByName('utm_campaign')) {
                                    redirectURL = `${redirectURL}&utm_campaign=${this.getParameterByName('utm_campaign')}`
                                }
                            }
                            window.top.location.href = redirectURL
                            redirected = true
                            return false
                        }
                    } else {
                        let redirectURL = `${redirections[redirect]}?redirected=true`
                        if (this.getParameterByName('utm_source')) {
                            redirectURL = `${redirectURL}&utm_source=${this.getParameterByName('utm_source')}`
                            if (this.getParameterByName('utm_medium')) {
                                redirectURL = `${redirectURL}&utm_medium=${this.getParameterByName('utm_medium')}`
                            }
                            if (this.getParameterByName('utm_campaign')) {
                                redirectURL = `${redirectURL}&utm_campaign=${this.getParameterByName('utm_campaign')}`
                            }
                        }
                        window.top.location.href = redirectURL
                        redirected = true
                        return false
                    }
                }
            }
        }
        if (!redirected && this.options.shopCountry !== 'RoW') {
            if (!this.location[this.options.countryKey] === 'CA' && this.options.shopCountry === 'US') {
                let redirectURL = `${redirections['ROW']}?redirected=true`
                if (this.getParameterByName('utm_source')) {
                    redirectURL = `${redirectURL}&utm_source=${this.getParameterByName('utm_source')}`
                    if (this.getParameterByName('utm_medium')) {
                        redirectURL = `${redirectURL}&utm_medium=${this.getParameterByName('utm_medium')}`
                    }
                    if (this.getParameterByName('utm_campaign')) {
                        redirectURL = `${redirectURL}&utm_campaign=${this.getParameterByName('utm_campaign')}`
                    }
                }
                window.top.location.href = redirectURL
                redirected = true
                return false
            }
        }
    }

    getLocation () {
        if (this.getParameterByName('redirected')) {
            sessionStorage.removeItem('ESC-GEOIP')
        }

        if (sessionStorage.getItem('ESC-GEOIP')) {
            let epoch = new Date().getTime()
            this.location = JSON.parse(sessionStorage.getItem('ESC-GEOIP'))
            if ((epoch - this.location.epoch) >= this.options.cacheTimeout) {
                sessionStorage.removeItem('ESC-GEOIP')
            }
        }

        if (!sessionStorage.getItem('ESC-GEOIP')) {
            return axios.get(this.options.endpoint).then((response) => {
                this.location = response.data
                this.location.epoch = new Date().getTime()
                sessionStorage.setItem('ESC-GEOIP', JSON.stringify(this.location))
            }).catch(() => {
                log.debug(this.constructor.name, 'Network Error (Adblock)')
                this.location = { country: this.options.shopCountry }
            })
        }
    }

    getParameterByName (name, url) {
        if (!url) url = window.location.href
        name = name.replace(/[[]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }
}

export default GEOIP



// WEBPACK FOOTER //
// ./src/resources/scripts/components/GEOIP.js